import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import Apiurl from "../Apiurl";

export default function Studentactiveoptions() {
  const [StudentData, setStudentData] = useState([]);
  const apiurl = Apiurl();

  async function fetchStudentData() {
    const batch = window.localStorage.getItem("academicyear");

    try {
      const response = await axios.get(
        apiurl +
          `studentreg/?student_id=&&branch=&course=&status=Active&std_name=`
      );
      console.log(response.data);
      setStudentData(response.data);
      // Handle the response data here
    } catch (error) {
      console.error(error);
      // Handle error here
      console.log("network error");
    }
  }
  const options = StudentData.map((student) => ({
    value: student.student_id,
    label: student.std_name + " - " + student.student_id,
  }));

  useEffect(() => {
    fetchStudentData();
  }, []);

  return options;
}
